var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _path, _rect1, _rect10, _rect11, _rect12, _path2, _rect13, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatternComplete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 125,
    viewBox: "0 0 230 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 229,
    height: 124,
    rx: 3.5,
    fill: "white",
    stroke: "#CAD5E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70.6055,
    y: 17.25,
    width: 70.15,
    height: 5.75,
    rx: 2.875,
    fill: "#CAD5E2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70.6055,
    y: 35.6504,
    width: 96.6,
    height: 5.75,
    rx: 2.875,
    fill: "#CAD5E2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 70.6055,
    y: 79.3496,
    width: 96.6,
    height: 5.75,
    rx: 2.875,
    fill: "#CAD5E2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 70.6055,
    y: 101.199,
    width: 96.6,
    height: 5.75,
    rx: 2.875,
    fill: "#CAD5E2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 70.6055,
    y: 57.5,
    width: 96.6,
    height: 5.75,
    rx: 2.875,
    fill: "#CAD5E2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 175.256,
    y: 35.6504,
    width: 36.8,
    height: 5.75,
    rx: 2.875,
    fill: "#CAD5E2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 175.256,
    y: 79.3496,
    width: 36.8,
    height: 5.75,
    rx: 2.875,
    fill: "#CAD5E2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 175.256,
    y: 101.199,
    width: 36.8,
    height: 5.75,
    rx: 2.875,
    fill: "#CAD5E2"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 175.256,
    y: 57.5,
    width: 36.8,
    height: 5.75,
    rx: 2.875,
    fill: "#CAD5E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H56V125H4C1.79086 125 0 123.209 0 121V4Z",
    fill: "#171B4B"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8047,
    y: 18.3984,
    width: 34.5,
    height: 3.45,
    rx: 1.725,
    fill: "white",
    fillOpacity: 0.7
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8047,
    y: 52.9004,
    width: 34.5,
    height: 3.45,
    rx: 1.725,
    fill: "white",
    fillOpacity: 0.7
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8047,
    y: 35.6504,
    width: 34.5,
    height: 3.45,
    rx: 1.725,
    fill: "white",
    fillOpacity: 0.7
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    y: 62,
    width: 56,
    height: 17,
    fill: "white",
    fillOpacity: 0.47
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4058 62.1103L44.197 53.694M52.1238 61.3802L53.4049 50.942M56.7966 63.1004L61.8617 57.2534",
    stroke: "#F03C0A",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8047,
    y: 69,
    width: 34.5,
    height: 3.45,
    rx: 1.725,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11174_15303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.569 99.2753L60.8805 105.225C60.8805 105.225 45.6631 96.6869 44.0621 95.6869C40.2093 93.2817 43.2696 87.752 47.3348 90.0815C48.8587 90.9551 52.4409 92.8234 52.9362 93.0385C54.0952 93.5419 55.1403 92.652 54.5473 90.9887C54.0349 89.5515 49.2201 76.0199 48.0081 72.6204C46.5978 68.6647 52.1134 66.518 53.5639 70.5867L57.1115 80.5374C57.3062 77.5134 60.6042 76.4216 62.3796 78.9736C63.4405 76.1741 66.715 76.3226 67.6955 78.8031C69.5351 76.5056 72.278 77.5431 73.3404 80.5231L76.9788 90.7284C78.0316 93.6815 76.3602 95.8821 77.5695 99.2741L77.569 99.2753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4474 70.9854C52.1811 70.2386 51.7745 69.8801 51.4071 69.7177C51.021 69.547 50.5638 69.5423 50.132 69.7053C49.3016 70.0188 48.654 70.9045 49.1241 72.2231C49.7302 73.9233 51.2371 78.1565 52.6563 82.1438C54.0757 86.1316 55.4073 89.8733 55.6634 90.5915C56.0463 91.6656 56.0058 92.8175 55.2779 93.6231C54.5294 94.4515 53.398 94.5329 52.4649 94.1276L52.4648 94.1276C51.9069 93.8852 48.2782 91.9899 46.7461 91.1116L46.7461 91.1116C45.9737 90.6691 45.3485 90.6476 44.893 90.7779C44.4201 90.9132 44.0165 91.2444 43.7591 91.697C43.2694 92.558 43.3345 93.7978 44.6261 94.6413L44.6886 94.6811L44.6888 94.6812C45.4599 95.1629 49.6286 97.5276 53.6529 99.7983C55.6544 100.928 57.606 102.026 59.0573 102.842C59.7829 103.25 60.3835 103.587 60.8026 103.822C60.8695 103.86 60.9318 103.895 60.9893 103.927L76.1268 98.5304C75.8114 97.0674 75.9262 95.8091 76.0359 94.7177C76.1746 93.3385 76.2855 92.3143 75.8623 91.1271L72.2239 80.9218C71.7772 79.6689 71.0441 79.0105 70.4402 78.8119C69.9248 78.6425 69.2753 78.7283 68.6204 79.5463C68.3563 79.876 67.9368 80.0401 67.5191 79.9769C67.1014 79.9137 66.7487 79.6328 66.5932 79.2395C66.2763 78.4379 65.6412 78.094 65.0715 78.0954C64.5271 78.0968 63.858 78.4185 63.4876 79.396C63.3317 79.8073 62.961 80.0983 62.5247 80.1519C62.0884 80.2056 61.6581 80.013 61.4068 79.6518C60.786 78.7594 60.0358 78.6337 59.504 78.7986C58.9479 78.971 58.363 79.5446 58.2941 80.6154C58.2579 81.177 57.8326 81.6356 57.2758 81.7133C56.719 81.7909 56.184 81.4663 55.995 80.9362L52.4474 70.9854ZM57.2652 77.4407C57.701 77.0227 58.2228 76.7112 58.8011 76.5319C59.9211 76.1847 61.1265 76.3718 62.1453 77.0767C62.9189 76.1962 63.9667 75.7255 65.0635 75.7226C66.1401 75.7199 67.1767 76.171 67.9376 76.9911C68.9282 76.352 70.068 76.1926 71.1782 76.5576C72.6712 77.0484 73.8407 78.3988 74.4564 80.1258L78.0948 90.3312C78.7244 92.0971 78.5261 93.6498 78.3946 94.9571C78.2618 96.278 78.1759 97.4475 78.6856 98.8769C78.791 99.1728 78.775 99.4983 78.6411 99.7822L78.6406 99.7833C78.5062 100.068 78.2639 100.288 77.9673 100.394L61.2787 106.343C60.9563 106.458 60.6 106.428 60.3014 106.261L60.8802 105.226C60.3067 106.251 60.3013 106.26 60.3012 106.261C60.301 106.26 60.3008 106.26 60.3006 106.26C60.3001 106.26 60.2994 106.26 60.2985 106.259C60.2967 106.258 60.2939 106.256 60.2902 106.254C60.2829 106.25 60.272 106.244 60.2575 106.236C60.2287 106.22 60.1858 106.196 60.1299 106.164C60.018 106.102 59.8537 106.009 59.644 105.892C59.2246 105.656 58.6238 105.319 57.8978 104.91C56.4458 104.094 54.493 102.995 52.49 101.865C48.5058 99.617 44.2657 97.2129 43.4352 96.6942L43.377 96.6574C40.9293 95.0907 40.6214 92.4161 41.6988 90.5218C42.233 89.5825 43.1161 88.8179 44.2399 88.4964C45.3811 88.1699 46.6627 88.3307 47.9228 89.0527L47.923 89.0528C49.4388 89.9217 52.9742 91.7629 53.407 91.951L53.4472 91.967C53.4785 91.9784 53.5043 91.9847 53.5245 91.9884C53.5418 91.9028 53.5488 91.7184 53.4308 91.3875C53.1744 90.6685 51.8424 86.9257 50.4233 82.9385C49.004 78.9509 47.4974 74.7185 46.8915 73.0191C45.9514 70.3821 47.3564 68.2166 49.2939 67.485C50.246 67.1255 51.3517 67.0998 52.3636 67.5473C53.3943 68.003 54.221 68.902 54.68 70.1895L57.2652 77.4407Z",
    fill: "#F03C0A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11174_15303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.9028,
    height: 40.6269,
    fill: "white",
    transform: "translate(33.8027 73.0078) rotate(-19.6221)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternComplete);
export default __webpack_public_path__ + "static/media/pattern_complete.4d57618b4e15c48f6f50c3c907db4d36.svg";
export { ForwardRef as ReactComponent };